var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.415,
    height: 13.879,
    viewBox: "0 0 10.415 13.879",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "unlock",
    transform: "translate(-7 -4.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5268",
    "data-name": "Path 5268",
    d: "M16.258,9.213H9.893V7.477a2.314,2.314,0,1,1,4.629,0,.58.58,0,0,0,.579.579c1.29-.156.168-2.54-.44-3.038A3.49,3.49,0,0,0,8.736,7.477V9.213H8.157A1.161,1.161,0,0,0,7,10.37v6.365a1.161,1.161,0,0,0,1.157,1.157h8.1a1.161,1.161,0,0,0,1.157-1.157V10.37a1.161,1.161,0,0,0-1.157-1.157ZM12.786,13.6v1a.579.579,0,0,1-1.157,0v-1a.934.934,0,1,1,1.157,0Z",
    fill: "#18ef35"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.ac585dcc70a3c1d09a71129db7fe52e2.svg";
export { ForwardRef as ReactComponent };